// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2t2BB","image":"Header_image__3eTxM","name":"Header_name__3d5w4","info":"Header_info__1rtBZ","infoRow":"Header_infoRow__37Xbo"};